import { Outlet } from 'react-router-dom'

export default function AuthLayout() {
  return (
    <div className="screen-min-h bg-white flex flex-col">
      <Outlet />
    </div>
  )
}
